// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__anchorLink___QFyWY {
  opacity: 0;
  position: relative;
  top: -90px;
  visibility: hidden;
}

.styles__buttonLocal___JRaPQ {
  margin-right: 20px;
}

.styles__buttonSecondary___Wy98U {
}

.styles__buttonSection___dlTum {
}

.styles__checkbox___MpCQZ {
  margin-right: 10px;
}

.styles__contactButtons___b0NH3,
.styles__sectionTitle___LRTwL {
  margin-bottom: 20px;
}

.styles__contentContainer___i2guo {
}

.styles__editContact___EMzTc {
  margin-right: 20px;
}

.styles__errorText___DOEmx {
}

.styles__errorWrapper___s6ecP {
}

.styles__formItem___oZCe7 {
}

.styles__formItemCurrency___fD_D8 {
  display: flex;
  flex-direction: column;
}

.styles__formItemHalf___GtB5Q {
}

.styles__formItemMono___JiNiW {
}

.styles__formWrapper___L04K7 {
  width: calc(99.9% * 2/3 - (30px - 30px * 2/3));
}

.styles__formWrapper___L04K7:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__formWrapper___L04K7:last-child {
  margin-right: 0;
}

.styles__formWrapper___L04K7:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__formWrapper___L04K7:nth-child(3n + 1) {
  clear: both;
}

.styles__input___OFGRn {
}

.styles__currencyInput___J4LOR {
  width: 25%;
}

.styles__inputLabelGroup___DyP7i {
  margin-top: 10px;
  margin-bottom: 10px;
}

.styles__inputLabelGroup___DyP7i input {
  margin-top: 10px;
  margin-right: 10px;
  margin-left: 10px;
  top: 2px;
  position: relative;
}

.styles__inputLabelGroup___DyP7i label {
  font-size: 14px;
}

.styles__label___z9gtq {
  text-align: left;
}

.styles__link___z8tOZ {
  background: rgba(255, 255, 255, 0.7);
  box-shadow: none;
  display: block;
}

.styles__link___z8tOZ:hover {
    background: white;
    box-shadow: none;
  }

.styles__menuLink___v5PKh {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  display: flex;
  align-self: center;
}

.styles__backLink___p0OLA {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
}

.styles__menuWrapper___OiPFb {
  width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
}

.styles__menuWrapper___OiPFb:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__menuWrapper___OiPFb:last-child {
  margin-right: 0;
}

.styles__menuWrapper___OiPFb:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__menuWrapper___OiPFb:nth-child(3n + 1) {
  clear: both;
}

.styles__navigationMenuWrapper___Z5Dxy {
  position: fixed;
  width: 452.86px;
}

@media (max-width: 1440px) {

.styles__navigationMenuWrapper___Z5Dxy {
    max-width: 31%;
    right: 20px;
}
  }

.styles__navigationSave___uIb1C {
  float: left;
  padding-left: 5px;
  padding-top: 20px;
}

.styles__removeButton___ulD4Q {
}

.styles__row___aSXr2 {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.styles__saveButton___QO_OZ {
}

.styles__section___HNr4n {
}

.styles__sectionSmall___U2mSn {
}

.styles__select___Te_DA {
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Account/components/Number/Edit/styles.css"],"names":[],"mappings":"AAIA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;AAEA;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;AAEA;;AAEA;EAEE,UAAU;AACZ;;AAEA;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAEhB,cAAc;AAMhB;;AAJE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;AAGF;EACE,mDAAc;EAEd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EAEE,mDAAa;AACf;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AAMjB;;AAJE;;AAJF;IAKI,cAAc;IACd,WAAW;AAEf;EADE;;AAGF;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;AAEA;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA","sourcesContent":["@value helpers: 'styles/helpers.css';\n@value colors: \"styles/colors.css\";\n@value gtGreen, gtBlue from colors;\n\n.anchorLink {\n  opacity: 0;\n  position: relative;\n  top: -90px;\n  visibility: hidden;\n}\n\n.buttonLocal {\n  composes: buttonLocal from helpers;\n  margin-right: 20px;\n}\n\n.buttonSecondary {\n  composes: buttonSecondary from helpers;\n}\n\n.buttonSection {\n  composes: buttons section from helpers;\n}\n\n.checkbox {\n  margin-right: 10px;\n}\n\n.contactButtons,\n.sectionTitle {\n  margin-bottom: 20px;\n}\n\n.contentContainer {\n  composes: content-container from helpers;\n}\n\n.editContact {\n  composes: buttonSecondary from helpers;\n  margin-right: 20px;\n}\n\n.errorText {\n  composes: errorText from helpers;\n}\n\n.errorWrapper {\n  composes: errorWrapper from helpers;\n}\n\n.formItem {\n  composes: formItem from helpers;\n}\n\n.formItemCurrency {\n  composes: formItem from helpers;\n  display: flex;\n  flex-direction: column;\n}\n\n.formItemHalf {\n  composes: formItemHalf from helpers;\n}\n\n.formItemMono {\n  composes: formItemMono from helpers;\n}\n\n.formWrapper {\n  lost-column: 2/3;\n}\n\n.input {\n  composes: input from helpers;\n}\n\n.currencyInput {\n  composes: input from helpers;\n  width: 25%;\n}\n\n.inputLabelGroup {\n  composes: clearfix from helpers;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.inputLabelGroup input {\n  margin-top: 10px;\n  margin-right: 10px;\n  margin-left: 10px;\n  top: 2px;\n  position: relative;\n}\n\n.inputLabelGroup label {\n  font-size: 14px;\n}\n\n.label {\n  composes: label from helpers;\n  text-align: left;\n}\n\n.link {\n  background: rgba(255, 255, 255, 0.7);\n  box-shadow: none;\n  composes: sectionTitle from helpers;\n  display: block;\n\n  &:hover {\n    background: white;\n    box-shadow: none;\n  }\n}\n\n.menuLink {\n  color: gtGreen;\n  composes: link;\n  display: flex;\n  align-self: center;\n}\n\n.backLink {\n  composes: menuLink;\n  color: gtBlue;\n}\n\n.menuWrapper {\n  lost-column: 1/3;\n}\n\n.navigationMenuWrapper {\n  position: fixed;\n  width: 452.86px;\n\n  @media (max-width: 1440px) {\n    max-width: 31%;\n    right: 20px;\n  }\n}\n\n.navigationSave {\n  float: left;\n  padding-left: 5px;\n  padding-top: 20px;\n}\n\n.removeButton {\n  composes: removeButton from helpers;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.saveButton {\n  composes: button from helpers;\n}\n\n.section {\n  composes: section from helpers;\n}\n\n.sectionSmall {\n  composes: sectionSmall from helpers;\n}\n\n.select {\n  composes: select from helpers;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `'styles/helpers.css'`,
	"colors": `"styles/colors.css"`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"anchorLink": `styles__anchorLink___QFyWY`,
	"buttonLocal": `styles__buttonLocal___JRaPQ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonLocal"]}`,
	"buttonSecondary": `styles__buttonSecondary___Wy98U ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonSecondary"]}`,
	"buttonSection": `styles__buttonSection___dlTum ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttons"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"checkbox": `styles__checkbox___MpCQZ`,
	"contactButtons": `styles__contactButtons___b0NH3`,
	"sectionTitle": `styles__sectionTitle___LRTwL`,
	"contentContainer": `styles__contentContainer___i2guo ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"editContact": `styles__editContact___EMzTc ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonSecondary"]}`,
	"errorText": `styles__errorText___DOEmx ${___CSS_LOADER_ICSS_IMPORT_1___.locals["errorText"]}`,
	"errorWrapper": `styles__errorWrapper___s6ecP ${___CSS_LOADER_ICSS_IMPORT_1___.locals["errorWrapper"]}`,
	"formItem": `styles__formItem___oZCe7 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItem"]}`,
	"formItemCurrency": `styles__formItemCurrency___fD_D8 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItem"]}`,
	"formItemHalf": `styles__formItemHalf___GtB5Q ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItemHalf"]}`,
	"formItemMono": `styles__formItemMono___JiNiW ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItemMono"]}`,
	"formWrapper": `styles__formWrapper___L04K7`,
	"input": `styles__input___OFGRn ${___CSS_LOADER_ICSS_IMPORT_1___.locals["input"]}`,
	"currencyInput": `styles__currencyInput___J4LOR ${___CSS_LOADER_ICSS_IMPORT_1___.locals["input"]}`,
	"inputLabelGroup": `styles__inputLabelGroup___DyP7i ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"label": `styles__label___z9gtq ${___CSS_LOADER_ICSS_IMPORT_1___.locals["label"]}`,
	"link": `styles__link___z8tOZ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"menuLink": `styles__menuLink___v5PKh styles__link___z8tOZ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"backLink": `styles__backLink___p0OLA styles__menuLink___v5PKh styles__link___z8tOZ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"menuWrapper": `styles__menuWrapper___OiPFb`,
	"navigationMenuWrapper": `styles__navigationMenuWrapper___Z5Dxy`,
	"navigationSave": `styles__navigationSave___uIb1C`,
	"removeButton": `styles__removeButton___ulD4Q ${___CSS_LOADER_ICSS_IMPORT_1___.locals["removeButton"]}`,
	"row": `styles__row___aSXr2`,
	"saveButton": `styles__saveButton___QO_OZ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"section": `styles__section___HNr4n ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"sectionSmall": `styles__sectionSmall___U2mSn ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]}`,
	"select": `styles__select___Te_DA ${___CSS_LOADER_ICSS_IMPORT_1___.locals["select"]}`
};
export default ___CSS_LOADER_EXPORT___;
